<!--
// app/components/pages/region-world-cup/IconArrowRightBracketTablesWorldCup.vue
-->
<script setup lang="ts">
type Props = {
  widthClass: string;
  bgColor: string;
  topPositionClass: string;
  textIndicator?: string;
  right?: boolean;
  vertical?: boolean;
  isGradientBg?: string;
  noPointer?: boolean;
  indicatorColor?: string;
  verticalNoCentered?: boolean;
};

defineProps<Props>();
</script>

<template>
  <div
    :class="[
      'absolute flex flex-col items-center justify-center -z-10',
      topPositionClass,
      right ? 'left-full' : 'right-full',
      { 'flex-row rotate-90 !left-0 !right-0': vertical },
      { 'flex-row rotate-90': verticalNoCentered },
    ]"
  >
    <span
      v-if="!!textIndicator"
      :class="['indicator-text', { '-rotate-90 ml-7 pl-6': vertical }, indicatorColor]"
      >{{ textIndicator }}</span
    >
    <div class="flex items-center px-0.5">
      <div
        :class="[widthClass, 'h-0.5']"
        :style="!!isGradientBg ? `background-image: ${isGradientBg}` : `background-color: ${bgColor};`"
      ></div>
      <div
        v-show="!noPointer"
        class="arrow-pointer-right border-l-8 rtl:border-r-8 rtl:border-l-0"
        :style="`border-color: ${bgColor};`"
      ></div>
    </div>
    <!--    <svg viewBox="0 0 112 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--      <path-->
    <!--        d="M111.51 9.73828L94.6562 0.00758553V19.469L111.51 9.73828ZM0.273438 11.4237H96.3416V8.05288H0.273438V11.4237Z"-->
    <!--        fill="currentColor"-->
    <!--      />-->
    <!--    </svg>-->
  </div>
</template>

<style scoped>
.indicator-text {
  @apply font-semibold -mt-[24px];
}

.arrow-pointer-right {
  width: 0;
  height: 0;
  border-top: 5px solid transparent !important;
  border-bottom: 5px solid transparent !important;
}
</style>
